import { MouseEventHandler } from "react";
import { isDesktop } from "react-device-detect";
import "./Button.scss";

export interface IButtonProps {
  children: string;
  onClick?: MouseEventHandler<HTMLButtonElement> | undefined;
  disabled?: boolean;
}

export const Button = (props: IButtonProps) => {
  const { children, onClick, disabled} = props;


  const buttonClass =
    (disabled
      ? "btn-primary-disabled"
      : "btn-primary");

  return (
    <>
      {isDesktop ? (
        <button
          className={buttonClass}
          onClick={onClick}
          disabled={disabled}
          onKeyDown={(e) => {}}
        >
          {children}
        </button>
      ) : (
        <button
          className={`${buttonClass} ${buttonClass}-mobile`}
          onClick={onClick}
          disabled={disabled}
          onKeyDown={(e) => {}}
        >
          {children}
        </button>
      )}
    </>
  );
};
